module.exports = __webpack_public_path__ + "static/media/tw.f05e6f35.webp";